import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Reusable Components
import CheckList_TwoColumns from "reusables/TextFormats/CheckList_TwoColumns";

// Images

function LetOnly_Section2() {
  const titlesDescriptionsObj = {
    "Property evaluation and rental pricing advice": "",
    "Professional photography and marketing": "",
    "Organizing and conducting viewings": "",
    "Comprehensive tenant screening and reference checks": "",
    "Drafting legally binding lease agreements": "",
    "Collecting deposits and first-month rent": "",
    "Transfer of utility bills and initial property setup": "",
  };
  return (
    <Container>
      <Grid container alignItems="center">
        <Grid item display={"flex"} flexDirection={"column"}>
          <Grid item>
            <SubTitleContents
              title="What’s Included in Our 'Let Only' Property Management Services?"
              contents=""
            />
          </Grid>
          <Grid item>
            <CheckList_TwoColumns titlesDescriptionsObj={titlesDescriptionsObj} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default LetOnly_Section2;
